"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClayIconSpriteContext = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _excluded = ["className", "spritemap", "symbol"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ClayIconSpriteContext = exports.ClayIconSpriteContext = /*#__PURE__*/_react.default.createContext('');
var Icon = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    spritemap = _ref.spritemap,
    symbol = _ref.symbol,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var spriteMapVal = _react.default.useContext(ClayIconSpriteContext);
  if (spritemap) {
    spriteMapVal = spritemap;
  }
  "production" !== "production" ? (0, _warning.default)(spriteMapVal, 'ClayIcon requires a `spritemap` via prop or ClayIconSpriteContext') : void 0;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, otherProps, {
    className: (0, _classnames.default)("lexicon-icon lexicon-icon-".concat(symbol), className),
    key: symbol,
    ref: ref,
    role: "presentation"
  }), /*#__PURE__*/_react.default.createElement("use", {
    href: "".concat(spriteMapVal, "#").concat(symbol)
  }));
});
Icon.displayName = 'ClayIcon';
var _default = exports.default = Icon;